import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

    constructor() { }

    writeTextToClipboard(text?: string) {
        if (!text) {
            text = '';
        }

        const isClipboardApiAvailable = navigator && 'clipboard' in navigator;

        if (isClipboardApiAvailable) {
            navigator.clipboard.writeText(text).then(function() {
                console.debug('Writing to clipboard succeeded');
            }, function() {
                console.error('Writing to clipboard failed');
            });
        } else {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    }

}
